import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import "vue-search-select/dist/VueSearchSelect.css";
import { AppConstants } from "./const";
// import pages
// Auth components
import Login from "./auth/Login.vue";
import Signup from "./auth/Signup.vue";
import ForgotPassword from "./auth/ForgotPassword";
import ResetPassword from "./auth/ResetPassword";
import Logout from "./auth/Logout";
import Activate from "./auth/Activate";

// User components
import Dashboard from "./user/Dashboard.vue";
import Profile from "./user/Profile.vue";
import CreateAccount from "./user/CreateAccount";
import CreateAccountDemo from "./user/CreateAccountDemo";
import infoAccount from "./user/infoAccount";
import partnership from "./user/Partnership.vue";

// Financial components
import DepositCrypto from "./financial/DepositCrypto.vue";
import WithdrawCrypto from "./financial/WithdrawCrypto";

// Verification components
import VerifyTimer from "./verification/VerifyTimer.vue";
import Identity from "./verification/Identity.vue";
import VerifyPoA from "./verification/VerifyPoA.vue";
import verifyPending from "./verification/verifyPending.vue";
// Admin components
import AdminLogin from "./admin/AdminLogin.vue";
import AdminDashboard from "./admin/AdminDashboard.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

import LandingPage from "./landing/LandingPage.vue";
import Account from "./landing/Account.vue";
import About from "./landing/About.vue";
import ContactUs from "./landing/ContactUs.vue";
import NotFound from "./components/NotFound.vue";

Vue.config.productionTip = false;

Vue.component("vue-phone-number-input", VuePhoneNumberInput);

Vue.use(VueRouter);
export const router = new VueRouter({
  base: "/",
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    // If user pressed back/forward button, use saved position
    if (savedPosition) {
      return savedPosition;
    }
    // If navigating to same path but different query (tab change), scroll to top
    if (to.path === from.path && to.query.tab !== from.query.tab) {
      return { x: 0, y: 0 };
    }
    // For all other navigation, scroll to top
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "Home",
      component: LandingPage,
      beforeEnter: (to, from, next) => {
        const userData = JSON.parse(localStorage.getItem("userData"));
        if (userData && userData.token) {
          next("/dashboard");
        } else if (!AppConstants.showLandingPage) {
          next("/login");
        } else {
          next();
        }
      },
    },
    { path: "/contact-us", name: "ContactUs", component: ContactUs },
    { path: "/about", name: "About", component: About },
    { path: "/account", name: "Account", component: Account },
    { path: "/login", name: "Login", component: Login },
    { path: "/signup", name: "Signup", component: Signup },
    { path: "/dashboard", name: "Dashboard", component: Dashboard },
    { path: "/auth/activate", name: "Activate", component: Activate },
    {
      path: "/deposit-crypto",
      name: "DepositCrypto",
      component: DepositCrypto,
    },
    {
      path: "/withdraw-crypto",
      name: "WithdrawCrypto",
      component: WithdrawCrypto,
    },
    { path: "/logout", name: "Logout", component: Logout },
    { path: "/profile", name: "Profile", component: Profile },
    {
      path: "/create-account",
      name: "CreateAccount",
      component: CreateAccount,
    },
    {
      path: "/create-account-demo",
      name: "CreateAccountDemo",
      component: CreateAccountDemo,
    },
    { path: "/info-account", name: "infoAccount", component: infoAccount },
    { path: "/partnership", name: "partnership", component: partnership },
    {
      path: "/forgot-password",
      name: "ForgotPassword",
      component: ForgotPassword,
    },
    {
      path: "/reset-password/:utoken",
      name: "ResetPassword",
      component: ResetPassword,
    },
    { path: "/verify-time", name: "VerifyTimer", component: VerifyTimer },
    { path: "/identity", name: "Identity", component: Identity },
    { path: "/verify-poa", name: "VerifyPoA", component: VerifyPoA },
    {
      path: "/verify-pending",
      name: "verifyPending",
      component: verifyPending,
    },
    { path: "/admin/login", name: "AdminLogin", component: AdminLogin },
    {
      path: "/admin/dashboard",
      name: "AdminDashboard",
      component: AdminDashboard,
    },
    { path: "/admin", redirect: "/admin/login" },

    // Temporary redirects to main site (opens in new tab)
    {
      path: "/about",
      name: "About",
      beforeEnter() {
        window.open("https://socrateslegacy.com/about", "_blank");
        return false;
      },
    },
    {
      path: "/contact-us",
      name: "ContactUs",
      beforeEnter() {
        window.open("https://socrateslegacy.com/contact-us", "_blank");
        return false;
      },
    },
    {
      path: "/regulations",
      name: "Regulations",
      beforeEnter() {
        window.open("https://socrateslegacy.com/regulations", "_blank");
        return false;
      },
    },
    {
      path: "/roadmap",
      name: "Roadmap",
      beforeEnter() {
        window.open("https://socrateslegacy.com/roadmap", "_blank");
        return false;
      },
    },
    {
      path: "/faq",
      name: "FAQ",
      beforeEnter() {
        window.open("https://socrateslegacy.com/faq-questions", "_blank");
        return false;
      },
    },
    {
      path: "/faq-questions",
      name: "FAQQuestions",
      beforeEnter() {
        window.open("https://socrateslegacy.com/faq-questions", "_blank");
        return false;
      },
    },
    // Catch-all 404 route - must be last
    {
      path: "*",
      name: "NotFound",
      component: NotFound,
    },
  ],
});

new Vue({
  router,
  render: (h) => h(App),
  mounted() {
    // Wait for all stylesheets and critical resources to load
    this.$nextTick(() => {
      // Check if all stylesheets are loaded
      const checkStylesLoaded = () => {
        const stylesheets = document.querySelectorAll('link[rel="stylesheet"]');
        let allLoaded = true;

        stylesheets.forEach((link) => {
          if (!link.sheet) {
            allLoaded = false;
          }
        });

        return allLoaded;
      };

      const showApp = () => {
        const app = document.getElementById("app");
        const loadingOverlay = document.getElementById("loading-overlay");
        const body = document.body;

        if (app) {
          app.classList.add("loaded");
        }

        if (body) {
          body.classList.add("loaded");
        }

        if (loadingOverlay) {
          loadingOverlay.classList.add("fade-out");
          setTimeout(() => {
            loadingOverlay.remove();
          }, 500);
        }
      };

      // Wait for styles to load or timeout after 3 seconds
      if (checkStylesLoaded()) {
        showApp();
      } else {
        const checkInterval = setInterval(() => {
          if (checkStylesLoaded()) {
            clearInterval(checkInterval);
            showApp();
          }
        }, 100);

        // Failsafe timeout
        setTimeout(() => {
          clearInterval(checkInterval);
          showApp();
        }, 3000);
      }
    });
  },
}).$mount("#app");
